import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../helpers/t";
import { useSelector, facilitySlotHistoryActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import { moment } from "../../../../../vendor";
import Loader from "../../../components/Loader";
import Paginator from "../../../components/paginator";

const ShowSlotHistoriesDialog = ({ handleCloseDialog, dispatch, facilitySlot }) => {
  const _facilitySlotHistories = useSelector(
    (state) => state.facility_slot_histories_data.facilitySlotHistories,
  );
  const [paginationLimit, setPaginationLimit] = useState(20);
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const [pag, setPag] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [facililtySlotHistoriesPending, setFacililtySlotHistoriesPending] = useState(false);

  useEffect(() => {
    if (facilitySlot !== null && !initialized) {
      dispatch(
        facilitySlotHistoryActions.getFacilitySlotHistories({
          token: Biscuit.get("token"),
          filter: {
            facility_slot_id: facilitySlot.id,
            direction: "desc",
            sort: "created",
            limit: paginationLimit,
            page: 1,
          },
        }),
      );
      setFacililtySlotHistoriesPending(true);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (_facilitySlotHistories.success === "" || facililtySlotHistoriesPending === false) {
      return;
    }
    if (_facilitySlotHistories.success === true) {
      console.log(_facilitySlotHistories, "_facilitySlotHistories");
      setPagination(_facilitySlotHistories.pagination);
      setPag(true);
    }
    setFacililtySlotHistoriesPending(false);
  }, [_facilitySlotHistories, facililtySlotHistoriesPending]);

  const loadNextPage = (page) => {
    if (!pagination.has_next_page) return;

    setFacililtySlotHistoriesPending(true);

    let requestFilter = {};
    requestFilter.sort = "created";
    requestFilter.direction = "desc";
    requestFilter.facility_slot_id = facilitySlot.id;

    requestFilter.limit = paginationLimit;
    requestFilter.page = page;
    // fetch next page
    dispatch(
      facilitySlotHistoryActions.getFacilitySlotHistories({
        token: Biscuit.get("token"),
        filter: requestFilter,
      }),
    );
  };

  return (
    <>
      {initialized && (
        <>
          <Dialog
            onClose={handleCloseDialog}
            aria-labelledby="changelogs-dialog-title"
            open={true}
            name="changeLogsDialog"
            id="multipleRecipientsDialog"
            maxWidth={"md"}
          >
            <header className="inb-multiple-recipients-header">
              <button
                onClick={handleCloseDialog}
                type="button"
                id="inb-multiple-recipients-dialog-close-button"
                className="button hollow secondary right button-close-multiple-recipients-dialog round"
                title={t("close show status")}
              >
                <i className="fi fi-x"></i>
              </button>
              {!facililtySlotHistoriesPending &&
              typeof _facilitySlotHistories.data !== "undefined" &&
              _facilitySlotHistories?.data?.length > 0 ? (
                <h4>
                  {t("status", null, "capital")} {_facilitySlotHistories.data[0].facility_name} Slot{" "}
                  {_facilitySlotHistories.data[0].facility_slot_nbr}
                </h4>
              ) : (
                <h4>{t("status", null, "capital")}</h4>
              )}

              {initialized &&
                typeof _facilitySlotHistories.data !== "undefined" &&
                _facilitySlotHistories?.data?.length > 0 &&
                !facililtySlotHistoriesPending &&
                pag &&
                typeof pagination !== "undefined" && (
                  <>
                    <br />
                    <Paginator
                      pagination={pagination}
                      itemsCountPerPage={paginationLimit}
                      setPaginationLimit={setPaginationLimit}
                      pageRangeDisplayed={5}
                      onChange={loadNextPage}
                      mediumWidth={12}
                      upper={true}
                    />
                    <br />
                  </>
                )}
              {!facililtySlotHistoriesPending &&
                typeof _facilitySlotHistories.data !== "undefined" &&
                _facilitySlotHistories?.data?.length > 0 && (
                  <>
                    <div id="inb-c-main-header">
                      <ul className="inb-tabs row">
                        <li className="tabs-title column medium-4">{t("date")}</li>
                        <li className="tabs-title column medium-4">{t("bike")}</li>
                        <li className="tabs-title column medium-4">{t("description")}</li>
                      </ul>
                    </div>
                  </>
                )}
              {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}
            </header>
            <div
              id="inb-c-main-multiple-recipients"
              className="inb-c-listing off-canvas-content"
              data-off-canvas-content=""
            >
              {!facililtySlotHistoriesPending &&
              typeof _facilitySlotHistories.data !== "undefined" &&
              _facilitySlotHistories?.data?.length > 0 ? (
                _facilitySlotHistories.data.map((facilitySlotHistory, index) => {
                  return (
                    <>
                      <div className="inb-c-item inb-c-item--recipient row" key={index}>
                        <div className="medium-4 small-12 column" title={t("date")}>
                          <span>
                            {moment(facilitySlotHistory.created).format("DD.MM.YY HH:mm")}
                          </span>
                        </div>
                        <div className="medium-4 small-12 column" title={t("bike")}>
                          <span>{facilitySlotHistory.resource_name}</span>
                        </div>
                        <div className={"medium-4 small-12 column"} title={t("counter")}>
                          <span>{facilitySlotHistory.description}</span>
                        </div>
                      </div>
                    </>
                  );
                })
              ) : facililtySlotHistoriesPending ? (
                <>
                  {" "}
                  <Loader mediumWidth={6} smallWidth={6} subLoaders={0} />
                </>
              ) : (
                <>
                  <div id="inb-app-collection-empty" className="inb-announcement">
                    <div className="inb-image-box">
                      <img src="assets/img/no_data.svg" />
                    </div>
                    <h3>{t("app_msg_collection_empty")}</h3>
                    <p>{t("app_msg_collection_empty_body")}</p>
                  </div>
                </>
              )}
            </div>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ShowSlotHistoriesDialog;
